import { motion } from "framer-motion";

export default function PageLoader() {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center backdrop-blur-md bg-white/60">
      <motion.div
        className="flex flex-col items-center"
        initial={{ opacity: 0.5, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0.5, scale: 0.9 }}
        transition={{ duration: 0.5 }}
      >
        <motion.img
          src="/assets/images/logo-talentlink-scroll.png"
          alt="Loading..."
          className="w-auto h-20 mb-4 animate-pulse drop-shadow-lg"
        />
      </motion.div>
    </div>
  );
}
